export default [
    {
        'id' : 0,
        'name' : '오노 사토시',
        'name_en' : 'Satoshi Ohno',
        'name_jp' : '大野 智',
        'birthday' : '1980.11.26',
        'birthplace' : '도쿄',
        'bloodtype' : 'A',
        'entranceday' : '1994.10.16',
        'portrait': 'https://www.johnnys-net.jp/material/AMIfv95l-CDf-Qi0MS8HTwinao7hHQpXteTTWZJgs5PZqWJv2l3DMQIWkTS_O5lqot3U35Yb8FhnrJTEp0NWWqxCdLUH2mvoPdThgXbT9xkSexyJEizyztQMV-OVg-Bbv5niZdX0ugAldJ_c_EF21-nUJSQ01YGQzy6Ys9AQpNltjEROhHDASiE?c=0&m=image%2Fjpeg',
        'color': '#00A9E9',
    },
    {
        'id' : 1,
        'name' : '사쿠라이 쇼',
        'name_en' : 'Sho Sakurai',
        'name_jp' : '櫻井 翔',
        'birthday' : '1982.01.25',
        'birthplace' : '도쿄',
        'bloodtype' : 'A',
        'entranceday' : '1995.10.22',
        'portrait': 'https://www.johnnys-net.jp/material/AMIfv95xGWdoInrrL6DI6EhNtP8biLgy5QevmdXqIW2R1MPpCj1VZyRLSh3SGl9z5UdrFoTsGDS2P-lfdXSK3kZMghFIbomfN8eCKLPSTjJrpnsAPsltXfAqaM8cTbJX402gU9CSRyhpTz6BruZ7aBvI8bp5Ffh5ZogR7CgYJutyWAJ2g2x1LB8?c=0&m=image%2Fjpeg',
        'color': '#EE2737',
    },
    {
        'id' : 2,
        'name' : '아이바 마사키',
        'name_en' : 'Masaki Aiba',
        'name_jp' : '相葉 雅紀',
        'birthday' : '1982.12.24',
        'birthplace' : '치바',
        'bloodtype' : 'AB',
        'entranceday' : '1998.08.15',
        'portrait': 'https://www.johnnys-net.jp/material/AMIfv969KmMN7XreNjXlF-cJ7VoJlrDrZvAhyUl3USic1PPvuzNSUh9EBd1siIkW4VxCYQPdtgC2WbKazExxPiJB0tLqib1l1h9lhSoa6tT13hy8wTAPBDnAceYvbhoQb3a3aWzxPBmRFAtvxWZ2fr4X4SeHO9ALupbf0DIjDQTiY0TmiCuipLM?c=0&m=image%2Fjpeg',
        'color': '#00AF66',
    },
    {
        'id' : 3,
        'name' : '니노미야 카즈나리',
        'name_en' : 'Kazunari Ninomiya',
        'name_jp' : '二宮 和也',
        'birthday' : '1983.06.17',
        'birthplace' : '도쿄',
        'bloodtype' : 'A',
        'entranceday' : '1996.06.19',
        'portrait': 'https://www.johnnys-net.jp/material/AMIfv967HhG_uYjCjSxObbqyy8-sUs6Fi7JNriZcBFG2pPvRP9VOTymYIwXYShWjw6dY7RVyptXTe1oUz3ArJo5gP2g5QCyXLcUxxdfMCc94VTBUF7O15rfemIzeFOalyyqm6xWFTysOJrGrOAoVfhsALpnEAPjVUbT0UYzNtbuSsmCN1DyG7aQ?c=0&m=image%2Fjpeg',
        'color': '#FFCD00',
    },
    {
        'id' : 4,
        'name' : '마츠모토 준',
        'name_en' : 'Jun Matsumoto',
        'name_jp' : '松本 潤',
        'birthday' : '1983.08.30',
        'birthplace' : '도쿄',
        'bloodtype' : 'A',
        'entranceday' : '1996.05.17',
        'portrait': 'https://www.johnnys-net.jp/material/AMIfv97NVGmn7SXBHmvHNCOUsGiQ_L2mjRV2yN-ZvZzvNEXklDRfp-BfKslUb7xRdYcZxOeMw83uHhU2NxIMEmmnlXUjBRYEwZvUp0WkhSLfAjTl0e0q9ponohk52pwf5p9L4JB_bBxtfMQJRfOL5hiFIgM1nmiwJfflMgDU6sTJzvLxuNbNgmo?c=0&m=image%2Fjpeg',
        'color': '#9B26B6',
    },
]